import { gsap } from "scripts/gsap";
export default function slideFadeInSlow(targets){
  let tl = gsap.timeline();
  tl.fromTo(targets, {
    translateY: "100%",
    opacity: 0,
    visibility: "visible",
    display: "inline-block",
  }, {
    translateY: "0%",
    opacity: 1,
    ease: "sine.inOut",
    duration: 0.25,
    stagger: {
      each: 0.05,
      ease: "sine.in",
    },
  });
  return tl;
}
